var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grade"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.92879 6.17788C9.63476 6.17788 11.0177 4.79492 11.0177 3.08894C11.0177 1.38297 9.63476 0 7.92879 0C6.22281 0 4.83984 1.38297 4.83984 3.08894C4.83984 4.79492 6.22281 6.17788 7.92879 6.17788Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.05105 24.6353V25.9648H9.23285V24.5497C9.33463 24.5989 9.44277 24.6387 9.55755 24.665C9.67278 24.6914 9.788 24.7041 9.90131 24.7041C10.3424 24.7041 10.7562 24.5122 11.0428 24.1924V15.0216C10.5902 14.8737 10.1699 14.708 9.78446 14.527L7.58216 14.5016C7.59324 14.0692 7.63342 13.6313 7.69178 13.1961C7.18434 12.768 6.7843 12.3342 6.47629 11.9388C5.48889 10.6784 5.18369 9.56681 5.11367 9.25614C5.03862 8.90367 5.10466 8.54839 5.29803 8.25057C5.4917 7.95261 5.78937 7.74786 6.13682 7.6743C6.22811 7.6548 6.32177 7.64505 6.41469 7.64505C7.03248 7.64505 7.57773 8.08335 7.71098 8.68695C7.71615 8.70704 7.72295 8.73024 7.73255 8.76333C7.75426 8.83468 7.7943 8.95286 7.85752 9.10295C7.95074 9.32557 8.10689 9.64274 8.34916 9.99743C8.37914 9.87142 8.40854 9.74777 8.43631 9.6287C8.8337 8.43892 8.36142 7.02829 7.24003 6.79163C6.1182 6.55498 4.47771 7.13007 3.78591 8.8818C2.85007 11.2956 2.63203 12.8609 2.93043 15.4998C3.3123 17.4096 4.76415 17.5854 5.97299 17.5539C6.01347 17.5529 6.0532 17.5515 6.09235 17.5503L9.606 17.5908L9.43464 18.3385H1.1818V8.23772H0V25.9648H1.1818V24.6353H8.05105ZM8.05105 19.8278V23.8473H1.1818V19.8278H8.05105Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0429 14.4172H10.2734C10.519 14.5215 10.7744 14.6204 11.0429 14.7109V14.4172Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.44985 8.84839C7.43759 8.80791 7.42962 8.77881 7.42592 8.7636C7.42385 8.75591 7.42297 8.75163 7.42282 8.75074C7.30036 8.19692 6.75392 7.84474 6.19803 7.96307C5.63948 8.08169 5.28316 8.63079 5.40164 9.18949C5.42468 9.29216 5.68069 10.4438 6.70945 11.7573C7.36388 12.5972 8.34995 13.4886 9.74965 14.1785V14.1217V12.5463V12.2508H10.0451H10.5165C9.48788 11.7193 8.80642 11.0721 8.33591 10.4797C7.95419 9.994 7.72019 9.53989 7.58517 9.2177C7.51736 9.05698 7.47438 8.9292 7.44985 8.84839Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.0449 12.5461V14.1218H11.3375V25.9153H13.1844V16.2641H22.8604V25.9153H24.707V14.1218H25.9996V12.5461H10.0449Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.7897 10.9915H12.4375V11.8778H18.7897V10.9915Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.7070e3af24879fb6067b97803061b6d7.svg";
export { ForwardRef as ReactComponent };